// @flow
import React, { Component } from "react";
import { getBaseUrl } from "../../../utils/helpers";
import styles from "./CompanyLogo.module.css";

type Props = {
  companyUrl: string,
  companyName?: ?string,
  className?: string
};

type State = {
  error: boolean
};

class CompanyLogo extends Component<Props, void> {
  static defaultProps = {
    companyName: null,
    className: ""
  };

  state = {
    error: false
  };

  render() {
    const { companyUrl, companyName, className } = this.props;
    const { error } = this.state;
    let src = "";

    if (error) {
      src =
        "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIzOHB4IiBoZWlnaHQ9IjM4cHgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT50YXJnZXQ8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGRlZnM+PC9kZWZzPiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPiAgICAgICAgPGcgaWQ9InRhcmdldCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4wMDAwMDAsIDEuMDAwMDAwKSIgc3Ryb2tlPSIjRkIwNTQxIiBzdHJva2Utd2lkdGg9IjIiPiAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIGN4PSIxOCIgY3k9IjE4IiByPSIxOCI+PC9jaXJjbGU+ICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbCIgY3g9IjE4IiBjeT0iMTgiIHI9IjEwLjgiPjwvY2lyY2xlPiAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIGN4PSIxOCIgY3k9IjE4IiByPSIzLjYiPjwvY2lyY2xlPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+";
    } else {
      src = `https://logo.clearbit.com/${getBaseUrl(companyUrl)}?size=150`;
    }

    return (
      <div className={className}>
        <img
          className={styles.DefaultErrorImg}
          onError={e => this.setState({ error: true })}
          alt={companyName && `${companyName} Logo`}
          src={src}
        />
      </div>
    );
  }
}

export default CompanyLogo;



// WEBPACK FOOTER //
// ./src/components/shared/CompanyLogo/CompanyLogo.js